import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility/utility";

const initialState = {
	accreditationContract: null,
	signedAccreditationContract: null,
	successMessage: null,
	errors: [],
	loading: false,
	investors: [],
	isSpinning: false,
	countries: [],
	successAlert: false
};

const getInverstorProfileStart = (state, action) => {
	return updateObject(state, {
		errors: [],
		loading: true,
		successMessage: null,
	});
};
/**
 * @description : Getting the axios `successMessage` from Saga
 * @param {param} state
 * @param {param} action
 */
const getInverstorProfileSuccess = (state, action) => {
	return updateObject(state, {
		investors: action.response,
		errors: [],
		loading: false,
	});
};

const getInverstorProfileFail = (state, action) => {
	return updateObject(state, {
		errors: action.errors,
		loading: false,
		successMessage: false,
	});
};
// remove this
const createInverstorProfileStart = (state, action) => {
	return updateObject(state, {
		errors: [],
		loading: true,
		successMessage: null,
		successAlert: false
	});
};
// remove this
const createInverstorProfileSuccess = (state, action) => {
	return updateObject(state, {
		successMessage: action,
		errors: [],
		loading: false,
		successAlert: true
	});
};
// remove this
const createInverstorProfileFail = (state, action) => {
	return updateObject(state, {
		errors: action.errors,
		loading: false,
		successMessage: false,
		successAlert: false
	});
};
// remove this
const getAccreditationContractSuccess = (state, action) => {
	return updateObject(state, {
		accreditationContract: action.response,
		signedAccreditationContract: null,
	});
};
// remove this
const getSignedAccreditationContractSuccess = (state, action) => {
	return updateObject(state, {
		signedAccreditationContract: action.response
	});
};
// remove this
const updateInverstorProfileStart = (state, action) => {
	return updateObject(state, {
		errors: [],
		loading: true,
		successMessage: null,
		successAlert: false
	});
};
// remove this
const updateInverstorProfileSuccess = (state, action) => {
	return updateObject(state, {
		updateSuccess: action.investor,
		errors: [],
		loading: false,
		successAlert: true
	});
};
// remove this
const updateInverstorProfileFail = (state, action) => {
	return updateObject(state, {
		errors: action.errors,
		loading: false,
		successMessage: false,
		successAlert: false
	});
};

const isSpinning = (state, action) => {
	return updateObject(state, {
		isSpinning: action.response,
	});
};

const clearSuccessAlert  = (state, action) => {
	return updateObject(state, {
		successAlert: false
	});
};

const getCountries = (state, action) => {
	return updateObject(state, {
		countries: action.response,
	});
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_INVESTOR_PROFILE_START:
			return getInverstorProfileStart(state, action);
		case actionTypes.GET_INVESTOR_PROFILE_SUCCESS:
			return getInverstorProfileSuccess(state, action);
		case actionTypes.GET_INVESTOR_PROFILE_FAIL:
			return getInverstorProfileFail(state, action);
		case actionTypes.CREATE_INVESTOR_PROFILE_START: // remove this
			return createInverstorProfileStart(state, action);
		case actionTypes.CREATE_INVESTOR_PROFILE_SUCCESS: // remove this
			return createInverstorProfileSuccess(state, action);
		case actionTypes.CREATE_INVESTOR_PROFILE_FAIL: // remove this
			return createInverstorProfileFail(state, action);
		case actionTypes.GET_ACCREDIATION_CONTRACT_SUCCESS: // remove this
			return getAccreditationContractSuccess(state, action);
		case actionTypes.GET_SIGNED_ACCREDIATION_CONTRACT_SUCCESS: // remove this
			return getSignedAccreditationContractSuccess(state, action);
		case actionTypes.UPDATE_INVESTOR_PROFILE_START: // remove this
			return updateInverstorProfileStart(state, action);
		case actionTypes.UPDATE_INVESTOR_PROFILE_SUCCESS: // remove this
			return updateInverstorProfileSuccess(state, action);
		case actionTypes.UPDATE_INVESTOR_PROFILE_FAIL: // remove this
			return updateInverstorProfileFail(state, action);
		case actionTypes.GET_COUNTRY_SUCCESS:
			return getCountries(state, action);
		case actionTypes.IS_SPINNING:
			return isSpinning(state, action);
		case actionTypes.CLEAR_SUCCESS_ALERT:
			return clearSuccessAlert(state, action);
		default:
			return state;
	}
};

export default reducer;
